"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
// @ts-ignore
var theme = require("./theme.module.scss");
var classcat_1 = require("classcat");
function StickyScrollbar(_a) {
    var className = _a.className, target = _a.target, extraData = _a.extraData, others = tslib_1.__rest(_a, ["className", "target", "extraData"]);
    var _b = React.useState(0), calculatedWidth = _b[0], setCalculatedWidth = _b[1];
    var _c = React.useState(false), showScrollbar = _c[0], setShowScrollbar = _c[1];
    var _d = React.useState(false), isOnBottom = _d[0], setOnBottom = _d[1];
    var onScroll = function (e) {
        target.current.scrollTo({ left: e.target.scrollLeft });
    };
    React.useEffect(function () {
        window.addEventListener("scroll", function () {
            setOnBottom((document.body.clientHeight - 15 < window.innerHeight + window.scrollY));
        });
    }, []);
    React.useEffect(function () {
        if (extraData && extraData.columnsWidth) {
            // @ts-ignore
            var sumColumnsWidth = Object.values(extraData.columnsWidth).reduce(function (a, b) { return a + b; });
            setCalculatedWidth(sumColumnsWidth);
        }
    }, [extraData.columnsWidth]);
    React.useEffect(function () {
        setShowScrollbar(target && target.current && calculatedWidth > target.current.offsetWidth);
    }, [target.current, calculatedWidth]);
    if (!showScrollbar) {
        return null;
    }
    return (React.createElement("div", tslib_1.__assign({ onScroll: onScroll }, others, { className: classcat_1.default([theme.stickyScrollbar, className]), style: { width: target.current.offsetWidth, bottom: isOnBottom ? 41 : 0 } }),
        React.createElement("div", { className: classcat_1.default([theme.scrollbarTrack, className]), style: { width: calculatedWidth } })));
}
exports.default = React.memo(StickyScrollbar);
